import axios from "axios";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import {
	Button,
	notification,
	Modal,
	Form,
	Row,
	Col,
	InputNumber,
	Select,
	Divider,
	Upload,
} from "antd";
import { CustomSpinner } from "../utils/CustomComponents";
import { UploadOutlined } from "@ant-design/icons";

const cylinderSizeOptions = [
	{ value: "4x8 cylinders", label: "4x8 cylinders" },
	{ value: "6x12 cylinders", label: "6x12 cylinders" },
	{ value: "4x4 cubes", label: "4x4 cubes" },
	{ value: "6x6 cubes", label: "6x6 cubes" },
];

const QAQCAddNotQCDataInternal = ({
	openModalForm,
	setOpenModalForm,
	load,
	setLoad,
	setRefresh,
}) => {
	const [loadingButton, setLoadingButton] = useState(true);
	const [loading, setLoading] = useState(true);
	const [apiNotification, contextHolder] = notification.useNotification();
	const [initialValues, setInitialValues] = useState({});
	const [disabled, setDisabled] = useState(true);

	const [form] = Form.useForm();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		if (load) assignValues();
	}, [load]);

	const assignValues = () => {
		setInitialValues({
			pourTestingSlump: load.pourTestingSlump,
			pourTestingConcreteTemperature: load.pourTestingConcreteTemperature,
			pourTestingCylinders: load.pourTestingCylinders,
			pourTestingCylinderSize: load.pourTestingCylinderSize,
		});
		setLoading(false);
		setLoadingButton(false);
		setDisabled(load.tested);
	};

	const saveQCData = async (values) => {
		try {
			const url = api + `/job/load/add/qc/pourtesting/${load.id}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
			const config = {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			};

			const formData = new FormData();

			formData.append("pourTestingSlump", values.pourTestingSlump.toString());
			formData.append(
				"pourTestingConcreteTemperature",
				values.pourTestingConcreteTemperature.toString(),
			);
			formData.append(
				"pourTestingCylinders",
				values.pourTestingCylinders.toString(),
			);
			formData.append(
				"pourTestingCylinderSize",
				values.pourTestingCylinderSize.toString(),
			);
			formData.append("qcTechnical", "");
			formData.append("pourTestingDateSampleTime", new Date());
			formData.append("lat", "null");
			formData.append("lng", "null");

			if (values.imagesSlump && values.imagesSlump.length > 0) {
				values.imagesSlump.forEach((file, index) => {
					const renamedFile = new File(
						[file.originFileObj],
						`slump_${index + 1}.${file.originFileObj.type.split("/")[1]}`,
						{
							type: file.originFileObj.type,
						},
					);
					formData.append("slump", renamedFile);
				});
				const metadata = values.imagesSlump.map((item) => ({
					date: new Date(),
				}));
				formData.append("slumpMetadata", JSON.stringify(metadata));
			}
			if (
				values.imagesConcreteTemperature &&
				values.imagesConcreteTemperature.length > 0
			) {
				values.imagesConcreteTemperature.forEach((file, index) => {
					const renamedFile = new File(
						[file.originFileObj],
						`concreteTemperature_${index + 1}.${file.originFileObj.type.split("/")[1]}`,
						{
							type: file.originFileObj.type,
						},
					);
					formData.append("concreteTemperature", renamedFile);
				});
				const metadata = values.imagesConcreteTemperature.map((item) => ({
					date: new Date(),
				}));
				formData.append(
					"concreteTemperatureMetadata",
					JSON.stringify(metadata),
				);
			}
			if (values.imagesCylinders && values.imagesCylinders.length > 0) {
				values.imagesCylinders.forEach((file, index) => {
					const renamedFile = new File(
						[file.originFileObj],
						`cylinders_${index + 1}.${file.originFileObj.type.split("/")[1]}`,
						{
							type: file.originFileObj.type,
						},
					);
					formData.append("cylinders", renamedFile);
				});
				const metadata = values.imagesCylinders.map((item) => ({
					date: new Date(),
				}));
				formData.append("cylindersMetadata", JSON.stringify(metadata));
			}
			if (
				values.imagesCylindersCuringArea &&
				values.imagesCylindersCuringArea.length > 0
			) {
				values.imagesCylindersCuringArea.forEach((file, index) => {
					const renamedFile = new File(
						[file.originFileObj],
						`cylindersCuringArea_${index + 1}.${file.originFileObj.type.split("/")[1]}`,
						{
							type: file.originFileObj.type,
						},
					);
					formData.append("cylindersCuringArea", renamedFile);
				});
				const metadata = values.imagesCylindersCuringArea.map((item) => ({
					date: new Date(),
				}));
				formData.append(
					"cylindersCuringAreaMetadata",
					JSON.stringify(metadata),
				);
			}

			const { data } = await axios.post(url, formData, config);
			if (data.success) {
				openNotification("success", "Success", data.message);

				setTimeout(() => {
					setLoad(null);
					setOpenModalForm(false);
					setRefresh((prev) => !prev);
				}, 2000);
			} else {
				setLoadingButton(false);
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			setLoadingButton(false);
			openNotification("error", "Error", "Error while trying to add qc data");
			console.error(err.message);
			return null;
		} finally {
			setLoadingButton(false);
		}
	};

	const onFinish = (values) => {
		setLoadingButton(true);

		// if (values.imagesSlump.length < 2) {
		// 	openNotification("warning", "Warning", "Slump Images (Min: 2 images)");
		// 	setLoadingButton(false);
		// } else if (values.imagesConcreteTemperature.length < 2) {
		// 	openNotification(
		// 		"warning",
		// 		"Warning",
		// 		"Concrete Temperature Images (Min: 2 images)",
		// 	);
		// 	setLoadingButton(false);
		// } else if (values.imagesCylinders.length < 2) {
		// 	openNotification(
		// 		"warning",
		// 		"Warning",
		// 		"Cylinders Images (Min: 2 images)",
		// 	);
		// 	setLoadingButton(false);
		// } else if (values.imagesCylindersCuringArea.length < 2) {
		// 	openNotification(
		// 		"warning",
		// 		"Warning",
		// 		"Cylinders Curing Area Images (Min: 2 images)",
		// 	);
		// 	setLoadingButton(false);
		// } else {
		saveQCData(values);
		// }
	};

	const normFile = (e) => {
		if (Array.isArray(e)) {
			return e;
		}
		return e?.fileList;
	};

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				onFinish={onFinish}
				style={{ marginTop: "20px" }}
				initialValues={initialValues}
			>
				<Row gutter={16}>
					<Col span={24} sm={12}>
						<Form.Item
							label="Slump (inches)"
							name="pourTestingSlump"
							rules={[
								{
									required: true,
									message: "Slump is required",
								},
							]}
						>
							<InputNumber
								size="large"
								style={{ width: "100%" }}
								formatter={(value) =>
									`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
								}
								parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
								disabled={disabled}
							/>
						</Form.Item>
					</Col>
					<Col span={24} xs={12}>
						<Form.Item
							label="Upload 2 pictures of the slump"
							name="imagesSlump"
							valuePropName="fileList"
							getValueFromEvent={normFile}
							// rules={[
							// 	{
							// 		required: true,
							// 		message: "Images are required",
							// 	},
							// ]}
						>
							<Upload
								beforeUpload={() => false}
								maxCount={10}
								multiple={true}
								accept=".png, .jpg, .jpeg"
							>
								<Button
									icon={<UploadOutlined />}
									size="large"
									disabled={disabled}
								>
									Upload
								</Button>
							</Upload>
						</Form.Item>
					</Col>
				</Row>
				<Divider />
				<Row gutter={16}>
					<Col span={24} sm={12}>
						<Form.Item
							label="Concrete Temp (°F)"
							name="pourTestingConcreteTemperature"
							rules={[
								{
									required: true,
									message: "Concrete Temperature is required",
								},
							]}
						>
							<InputNumber
								size="large"
								style={{ width: "100%" }}
								formatter={(value) =>
									`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
								}
								parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
								disabled={disabled}
							/>
						</Form.Item>
					</Col>
					<Col span={24} xs={12}>
						<Form.Item
							label="Upload 2 pictures of the concrete temperature"
							name="imagesConcreteTemperature"
							valuePropName="fileList"
							getValueFromEvent={normFile}
							// rules={[
							// 	{
							// 		required: true,
							// 		message: "Images are required",
							// 	},
							// ]}
						>
							<Upload
								beforeUpload={() => false}
								maxCount={10}
								multiple={true}
								accept=".png, .jpg, .jpeg"
							>
								<Button
									icon={<UploadOutlined />}
									size="large"
									disabled={disabled}
								>
									Upload
								</Button>
							</Upload>
						</Form.Item>
					</Col>
				</Row>
				<Divider />
				<Row gutter={16}>
					<Col span={24} sm={8}>
						<Form.Item
							label="How many cylinders made?"
							name="pourTestingCylinders"
							rules={[
								{
									required: true,
									message: "Cylinders are required",
								},
							]}
						>
							<InputNumber
								size="large"
								style={{ width: "100%" }}
								formatter={(value) =>
									`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
								}
								parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
								disabled={disabled}
							/>
						</Form.Item>
					</Col>
					<Col span={24} sm={8}>
						<Form.Item
							label="Cylinder size / type"
							name="pourTestingCylinderSize"
							rules={[
								{
									required: true,
									message: "Cylinder size is required",
								},
							]}
						>
							<Select
								style={{
									width: "100%",
								}}
								size="large"
								placeholder="Please select cylinder size"
								options={cylinderSizeOptions}
								showSearch
								disabled={disabled}
							/>
						</Form.Item>
					</Col>
					<Col span={24} xs={8}>
						<Form.Item
							label="Upload 2 pictures of the cylinders"
							name="imagesCylinders"
							valuePropName="fileList"
							getValueFromEvent={normFile}
							// rules={[
							// 	{
							// 		required: true,
							// 		message: "Images are required",
							// 	},
							// ]}
						>
							<Upload
								beforeUpload={() => false}
								maxCount={10}
								multiple={true}
								accept=".png, .jpg, .jpeg"
							>
								<Button
									icon={<UploadOutlined />}
									size="large"
									disabled={disabled}
								>
									Upload
								</Button>
							</Upload>
						</Form.Item>
					</Col>
				</Row>
				<Divider />
				<Row gutter={16}>
					<Col span={24} xs={12}>
						<Form.Item
							label="Upload 2 pictures of the cylinders initial curing area"
							name="imagesCylindersCuringArea"
							valuePropName="fileList"
							getValueFromEvent={normFile}
							// rules={[
							// 	{
							// 		required: true,
							// 		message: "Images are required",
							// 	},
							// ]}
						>
							<Upload
								beforeUpload={() => false}
								maxCount={10}
								multiple={true}
								accept=".png, .jpg, .jpeg"
							>
								<Button
									icon={<UploadOutlined />}
									size="large"
									disabled={disabled}
								>
									Upload
								</Button>
							</Upload>
						</Form.Item>
					</Col>
				</Row>

				<Row gutter={16}>
					<Col span={24} sm={12} md={4}>
						<Button
							type="primary"
							htmlType="submit"
							loading={loadingButton}
							size="large"
							style={{
								width: "100%",
							}}
							disabled={disabled || loadingButton}
						>
							Create
						</Button>
					</Col>
				</Row>
			</Form>
		);
	};

	return (
		<Modal
			title={`Ticket: ${load?.ticket}`}
			open={openModalForm}
			onCancel={() => {
				setLoad(null);
				setOpenModalForm(false);
			}}
			footer={null}
			width={1500}
			centered
		>
			{loading ? <CustomSpinner /> : <CustomForm />}
			{contextHolder}
		</Modal>
	);
};

export default QAQCAddNotQCDataInternal;
